import { render } from "./DetailNana.vue?vue&type=template&id=48eede4c&scoped=true"
import script from "./DetailNana.vue?vue&type=script&lang=js"
export * from "./DetailNana.vue?vue&type=script&lang=js"

import "./DetailNana.vue?vue&type=style&index=0&id=48eede4c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-48eede4c"

export default script